module.exports = __webpack_public_path__ + "img/9.8645a755.png";